import { Pressable, StyleSheet, View } from 'react-native';
import { tokens } from '../../theme/tokens';
import { AppButton } from '../ui/AppButton';
import { AppCard } from '../ui/AppCard';
import { AppInput } from '../ui/AppInput';
import { AppText } from '../ui/AppText';

type AddTaskSheetProps = {
  visible: boolean;
  taskName: string;
  subject: string;
  estimatedMinutes: number;
  taskDate: string;
  onChangeTaskName: (value: string) => void;
  onChangeSubject: (value: string) => void;
  onChangeEstimatedMinutes: (value: number) => void;
  onChangeTaskDate: (value: string) => void;
  onSubmit: () => void;
  onClose: () => void;
};

export function AddTaskSheet({
  visible,
  taskName,
  subject,
  estimatedMinutes,
  taskDate,
  onChangeTaskName,
  onChangeSubject,
  onChangeEstimatedMinutes,
  onChangeTaskDate,
  onSubmit,
  onClose,
}: AddTaskSheetProps) {
  if (!visible) {
    return null;
  }

  return (
    <View style={styles.overlay}>
      <Pressable accessibilityRole="button" onPress={onClose} style={styles.backdrop} />
      <AppCard style={styles.sheet}>
        <View style={styles.dragHandle} />
        <AppText variant="subtitle" weight="bold" align="center">
          添加任务
        </AppText>
        <View style={styles.field}>
          <AppText variant="caption" tone="muted" weight="bold">
            任务名称
          </AppText>
          <AppInput value={taskName} onChangeText={onChangeTaskName} placeholder="输入任务名称..." />
        </View>
        <View style={styles.row}>
          <View style={styles.inlineField}>
            <AppText variant="caption" tone="muted" weight="bold">
              学科标签
            </AppText>
            <AppInput
              value={subject}
              onChangeText={onChangeSubject}
              placeholder="学科标签"
              style={styles.inlineInput}
            />
          </View>
          <View style={styles.inlineField}>
            <AppText variant="caption" tone="muted" weight="bold">
              预计时间
            </AppText>
            <AppInput
              value={String(estimatedMinutes)}
              keyboardType="number-pad"
              onChangeText={(value) => onChangeEstimatedMinutes(Number(value) || 0)}
              placeholder="预计时间"
              style={styles.inlineInput}
            />
          </View>
        </View>
        <View style={styles.field}>
          <AppText variant="caption" tone="muted" weight="bold">
            日期
          </AppText>
          <AppInput value={taskDate} onChangeText={onChangeTaskDate} placeholder="日期" />
        </View>
        <AppButton label="添加" onPress={onSubmit} disabled={!taskName.trim()} />
      </AppCard>
    </View>
  );
}

const styles = StyleSheet.create({
  overlay: {
    ...StyleSheet.absoluteFillObject,
    justifyContent: 'flex-end',
  },
  backdrop: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: 'rgba(0,0,0,0.24)',
  },
  sheet: {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    gap: tokens.spacing.md,
  },
  dragHandle: {
    alignSelf: 'center',
    width: 42,
    height: 4,
    borderRadius: 2,
    backgroundColor: tokens.colors.border,
  },
  row: {
    flexDirection: 'row',
    gap: tokens.spacing.md,
  },
  field: {
    gap: tokens.spacing.xs,
  },
  inlineField: {
    flex: 1,
    gap: tokens.spacing.xs,
  },
  inlineInput: {
    flex: 1,
  },
});
